/* eslint-disable indent */
import { useLocation } from 'react-router-dom';
import { useUser } from '../../../hooks/useUser';
import { Song } from '../../../interfaces/userInterfaces';
import { useMediaPlayer } from '../../../hooks/useMediaPlayer';

export const SongDisplay = (song: Song) => {
  const location = useLocation();
  const mediaPage = new RegExp('^/media/[0-9]*$');
  const showControls = mediaPage.test(location.pathname);

  const { user } = useUser();
  const { addToPlaylist } = useMediaPlayer();

  let songData;
  showControls ? (songData = location.state.user) : (songData = song);

  const handleAddToPlaylist = () => {
    addToPlaylist(song);
  };

  return (
    <div className="auido-track-container">
      {songData.image ? <img src={songData.image} /> : null}
      <audio
        className="audio-tag-proper"
        id={`audio-track-${songData.song_id}`}
        controls
        controlsList="nodownload"
      >
        <source src={songData.media} type="audio/mp3" />
      </audio>
      <span className="audio-track-details">
        <p className="audio-track-details-info">Artist: {songData.username}</p>
        <p className="audio-track-details-info">Title: {songData.title}</p>
        <p className="audio-track-details-info">Description: {songData.description}</p>
        <span>
          <button onClick={handleAddToPlaylist}>Add To Playlist</button>
          {user?.username === songData.username && location.pathname !== '/' ? (
            <>
              <button>Delete</button> <button>Edit</button>
            </>
          ) : null}
        </span>
      </span>
    </div>
  );
};
